import { render } from "./Users.vue?vue&type=template&id=ca07f200&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=ca07f200&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca07f200"]])

export default __exports__